export default "__VITE_ASSET__94a0a28e__"